<template>
  <div class="customActive">
    <img
      class="banner mb56"
      src="https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/h5/618/banner4.png"
    />
    <div class="container ">
      <div v-for="item in showData.subList || []" :key="item.categoryId">
        <h1 class="itemTitle">{{ item.categoryName }}</h1>
        <div class="content">
          <Item618
            v-for="i in item.skuList || []"
            :key="i.skuId"
            :goods="i"
          ></Item618>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Item618 from './components/item618.vue'
export default {
  components: { Item618 },
  data () {
    return {
      foregroundCategoryId: '',
      showData: {}
    }
  },
  created () {
    this.foregroundCategoryId = this.$route.query.foregroundCategoryId
    this.getList()
  },
  methods: {
    getList () {
      this.$http
        .post(`/front/cross/commodity-user/web/subCategorySkus`, {
          foregroundCategoryId: this.foregroundCategoryId
        })
        .then(({ data: { data, code } }) => {
          if (code === 0) {
            this.showData = data || {}
            document.title = this.showData.categoryName
          }
        })
    }
  }
}
</script>

<style lang="scss">
.customActive {
  background: #572cc2;
  .banner {
    width: 100%;
  }
  .mtb56 {
    margin: 112px 0;
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
  }
  .itemTitle {
    height: 90px;
    text-align: center;
    position: relative;
    background-image: url("https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/h5/618/box.png");
    background-position: 50% 50%;
    background-size: contain;
    background-repeat: no-repeat;
    font-size: 28px;
    color: #ffffff;
    line-height: 90px;
    letter-spacing: 2px;
    z-index: 1;
    margin: 56px 0 32px 0;
  }
}
</style>
